import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/loader.svg` */
export const LoaderIcon = createTripletGlyphIcon('LoaderIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.98413 10.7943C8.37073 10.7943 8.68433 11.1079 8.68433 11.4945V14.1615C8.68398 14.5478 8.37051 14.8607 7.98413 14.8607C7.5979 14.8605 7.28429 14.5477 7.28394 14.1615V11.4945C7.28394 11.108 7.59768 10.7945 7.98413 10.7943Z"
        fill="currentColor"
      />
      <path
        d="M9.95288 10.0004C10.2263 9.72703 10.6698 9.72701 10.9431 10.0004L12.8289 11.8861C13.1019 12.1595 13.1011 12.6021 12.8279 12.8754C12.5546 13.1486 12.112 13.1494 11.8386 12.8763L9.95288 10.9906C9.67951 10.7172 9.67951 10.2737 9.95288 10.0004Z"
        fill="currentColor"
      />
      <path
        d="M5.02612 9.96423C5.29949 9.69087 5.74299 9.69087 6.01636 9.96423C6.28971 10.2376 6.28972 10.6811 6.01636 10.9545L4.13062 12.8402C3.85723 13.1133 3.41465 13.1125 3.14136 12.8392C2.86807 12.5659 2.86724 12.1234 3.14038 11.85L5.02612 9.96423Z"
        fill="currentColor"
      />
      <path
        d="M4.49976 7.30408C4.88632 7.30412 5.19995 7.6177 5.19995 8.00427C5.19978 8.3907 4.88621 8.70443 4.49976 8.70447H1.84448C1.45799 8.70447 1.14446 8.39072 1.14429 8.00427C1.14429 7.61767 1.45788 7.30408 1.84448 7.30408H4.49976Z"
        fill="currentColor"
      />
      <path
        d="M14.1423 7.30408C14.5289 7.30408 14.8425 7.61767 14.8425 8.00427C14.8424 8.39072 14.5288 8.70447 14.1423 8.70447H11.4998C11.1134 8.70429 10.7997 8.39061 10.7996 8.00427C10.7996 7.61778 11.1133 7.30425 11.4998 7.30408H14.1423Z"
        fill="currentColor"
      />
      <path
        d="M3.13354 3.15955C3.4068 2.88632 3.85039 2.88653 4.12378 3.15955L6.00952 5.04529C6.28265 5.31867 6.28279 5.76223 6.00952 6.03552C5.73623 6.30881 5.29267 6.30866 5.01929 6.03552L3.13354 4.14978C2.86053 3.87638 2.86029 3.4328 3.13354 3.15955Z"
        fill="currentColor"
      />
      <path
        d="M11.8289 3.1322C12.1022 2.85884 12.5457 2.85884 12.8191 3.1322C13.0923 3.40558 13.0924 3.84912 12.8191 4.12244L10.9333 6.00818C10.66 6.28119 10.2174 6.28032 9.94409 6.0072C9.67083 5.73394 9.67005 5.29134 9.94312 5.01794L11.8289 3.1322Z"
        fill="currentColor"
      />
      <path
        d="M7.98413 1.13123C8.37068 1.13123 8.68425 1.44488 8.68433 1.83142V4.49841C8.68415 4.88486 8.37062 5.19763 7.98413 5.19763C7.59779 5.19746 7.28411 4.88475 7.28394 4.49841V1.83142C7.28401 1.44499 7.59773 1.1314 7.98413 1.13123Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.98926 12.1855C9.40347 12.1855 9.73926 12.5213 9.73926 12.9355V15.9355C9.739 16.3495 9.40331 16.6855 8.98926 16.6855C8.57532 16.6854 8.23952 16.3495 8.23926 15.9355V12.9355C8.23926 12.5214 8.57516 12.1857 8.98926 12.1855Z"
        fill="currentColor"
      />
      <path
        d="M11.2305 11.2812C11.5234 10.9884 11.9981 10.9884 12.291 11.2812L14.4121 13.4023C14.705 13.6952 14.705 14.17 14.4121 14.4629C14.1192 14.7557 13.6444 14.7558 13.3516 14.4629L11.2305 12.3418C10.9376 12.0489 10.9377 11.5742 11.2305 11.2812Z"
        fill="currentColor"
      />
      <path
        d="M5.68848 11.2402C5.98139 10.9476 6.45623 10.9474 6.74902 11.2402C7.0418 11.533 7.04162 12.0079 6.74902 12.3008L4.62793 14.4229C4.33504 14.7157 3.8593 14.7157 3.56641 14.4229C3.27351 14.13 3.27351 13.6542 3.56641 13.3613L5.68848 11.2402Z"
        fill="currentColor"
      />
      <path
        d="M5.06934 8.25879C5.48351 8.25883 5.81934 8.5946 5.81934 9.00879C5.8192 9.42286 5.48343 9.75874 5.06934 9.75879H2.08203C1.6679 9.75879 1.33216 9.42289 1.33203 9.00879C1.33203 8.59458 1.66782 8.25879 2.08203 8.25879H5.06934Z"
        fill="currentColor"
      />
      <path
        d="M15.918 8.25879C16.332 8.25905 16.668 8.59474 16.668 9.00879C16.6678 9.42273 16.3319 9.75853 15.918 9.75879H12.9453C12.5312 9.75879 12.1954 9.42289 12.1953 9.00879C12.1953 8.59458 12.5311 8.25879 12.9453 8.25879H15.918Z"
        fill="currentColor"
      />
      <path
        d="M3.55957 3.58594C3.85247 3.29307 4.32723 3.29305 4.62012 3.58594L6.74121 5.70703C7.0341 5.99992 7.03408 6.47468 6.74121 6.76758C6.44832 7.06047 5.97356 7.06047 5.68066 6.76758L3.55957 4.64648C3.26668 4.35359 3.26668 3.87883 3.55957 3.58594Z"
        fill="currentColor"
      />
      <path
        d="M13.3408 3.55371C13.6336 3.26101 14.1085 3.26128 14.4014 3.55371C14.6943 3.8466 14.6943 4.32234 14.4014 4.61523L12.2803 6.73633C11.9874 7.02899 11.5125 7.02911 11.2197 6.73633C10.9269 6.44351 10.9271 5.96869 11.2197 5.67578L13.3408 3.55371Z"
        fill="currentColor"
      />
      <path
        d="M8.98926 1.31445C9.40342 1.31445 9.73917 1.65031 9.73926 2.06445V5.06445C9.73926 5.47867 9.40347 5.81445 8.98926 5.81445C8.57516 5.81432 8.23926 5.47859 8.23926 5.06445V2.06445C8.23934 1.65039 8.57521 1.31458 8.98926 1.31445Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9766 16.3408C12.4736 16.3408 12.877 16.7442 12.877 17.2412V21.2412C12.877 21.7383 12.4736 22.1416 11.9766 22.1416C11.4795 22.1416 11.0762 21.7383 11.0762 21.2412V17.2412C11.0762 16.7442 11.4795 16.3408 11.9766 16.3408Z"
        fill="currentColor"
      />
      <path
        d="M15.0352 15.1064C15.3866 14.755 15.9571 14.755 16.3086 15.1064L19.1367 17.9346C19.4882 18.286 19.4881 18.8565 19.1367 19.208C18.7852 19.5595 18.2148 19.5595 17.8633 19.208L15.0352 16.3799C14.6837 16.0284 14.6837 15.4579 15.0352 15.1064Z"
        fill="currentColor"
      />
      <path
        d="M7.64551 15.0518C7.99701 14.7007 8.5676 14.7004 8.91895 15.0518C9.27026 15.4031 9.27002 15.9737 8.91895 16.3252L6.08984 19.1543C5.73836 19.5055 5.16779 19.5056 4.81641 19.1543C4.46503 18.8029 4.46522 18.2324 4.81641 17.8809L7.64551 15.0518Z"
        fill="currentColor"
      />
      <path
        d="M6.75 11.1055C7.24701 11.1055 7.65039 11.5088 7.65039 12.0059C7.65039 12.5029 7.24701 12.9062 6.75 12.9062H2.7666C2.26955 12.9062 1.86621 12.5029 1.86621 12.0059C1.86621 11.5088 2.26955 11.1055 2.7666 11.1055H6.75Z"
        fill="currentColor"
      />
      <path
        d="M21.2139 11.1055C21.7109 11.1055 22.1143 11.5088 22.1143 12.0059C22.1143 12.5029 21.7109 12.9062 21.2139 12.9062H17.25C16.7529 12.9062 16.3496 12.5029 16.3496 12.0059C16.3496 11.5088 16.7529 11.1055 17.25 11.1055H21.2139Z"
        fill="currentColor"
      />
      <path
        d="M4.80664 4.8457C5.1581 4.49428 5.72861 4.49428 6.08008 4.8457L8.9082 7.67383C9.25966 8.02529 9.25964 8.59579 8.9082 8.94727C8.55673 9.29874 7.98624 9.29874 7.63477 8.94727L4.80664 6.11914C4.4552 5.76767 4.45518 5.19716 4.80664 4.8457Z"
        fill="currentColor"
      />
      <path
        d="M17.8496 4.80371C18.2011 4.45246 18.7716 4.45231 19.123 4.80371C19.4742 5.15513 19.4742 5.72573 19.123 6.07715L16.2939 8.90527C15.9425 9.25675 15.372 9.25675 15.0205 8.90527C14.6693 8.55378 14.6691 7.98322 15.0205 7.63184L17.8496 4.80371Z"
        fill="currentColor"
      />
      <path
        d="M11.9766 1.84668C12.4736 1.84668 12.8768 2.25011 12.877 2.74707V6.74707C12.877 7.24413 12.4736 7.64746 11.9766 7.64746C11.4795 7.64746 11.0762 7.24413 11.0762 6.74707V2.74707C11.0763 2.25011 11.4796 1.84668 11.9766 1.84668Z"
        fill="currentColor"
      />
    </svg>
  ),
});
